import { render, staticRenderFns } from "./UICreateReplyModal.vue?vue&type=template&id=1539aa26"
import script from "./UICreateReplyModal.vue?vue&type=script&lang=js"
export * from "./UICreateReplyModal.vue?vue&type=script&lang=js"
import style0 from "./UICreateReplyModal.vue?vue&type=style&index=0&id=1539aa26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
